import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL.startsWith("http") && !process.env.REACT_APP_API_BASE_URL.includes("localhost:5000"))
    ? process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')
    : "https://engdemyeducation.com";

const API = axios.create({ baseURL: API_BASE });

API.interceptors.request.use((req) => {
    const userInfo = localStorage.getItem("user_info");

    if (userInfo) {
        try {
            const parsedUser = JSON.parse(userInfo);
            if (parsedUser.token) {
                req.headers.Authorization = `Bearer ${parsedUser.token}`;
            }
        } catch (error) {
            console.error("Failed to parse user token:", error);
        }
    }

    return req;
});

export const signIn = (data) => API.post("/users/login", data);
//export const signInGoogle = (accessToken) => API.post("/users/login", { googleAccessToken: accessToken });
export const signInGoogle = (formData) => API.post("/users/login", formData);
export const signUp = (data) => API.post("/users/signup", data);
export const signUpGoogle = (accessToken) => API.post("/users/signup", { googleAccessToken: accessToken });

export const getUserById = (userId) => API.get(`/users/getUserById/${userId}`);
export const updateUser = (userId, data) => API.put(`/users/updateUser/${userId}`, data);

export const updatePassword = (userId, data) => API.put(`/users/updatePassword/${userId}`, data);

// Question-related API call
//export const fetchQuestions = () => API.get("/questions");

//export const fetchWritingQuestions = () => API.get("/api/writing");

// Speaking questions
export const fetchQuestions = (testNumber) =>
    API.get(`/questions?testNumber=${Number(testNumber)}`);


export const fetchWritingQuestions = (testNumber) =>
    API.get(`/writing?testNumber=${testNumber}`);


// Reading endpoints
export const fetchReadings = () => API.get("/CelpipReading");

export const verifyEmail = async (emailData) => {
    return await axios.post('/verify-email', emailData);
};

export const resendVerification = (email) => API.post("/users/resend-verification", { email });

// Save a new reading attempt
export const saveReadingAttempt = (attemptData) =>
    API.post(`api/readingAttempts/attempt`, attemptData);

// Reading Attempts
export const getUserReadingAttempts = (userId) =>
    API.get(`/api/reading-attempts/user/${userId}`).then(res => res.data);

// Save a new listening attempt
export const saveListeningAttempt = (data) =>
    API.post(`/listening-attempts`, data);

// Listening Attempts
export const getUserListeningAttempts = (userId) =>
    API.get(`/api/listening-Attempts/user/${userId}`).then(res => res.data);

// Save a new writing attempt
export const saveWritingAttempt = (attemptData) =>
    API.post("/api/writing-attempts", attemptData);

export const getUserWritingAttempts = (userId) =>
    API.get(`/api/writing-attempts/user/${userId}`)
        .then(res => res.data); // res.data is already an array

// Speaking Attempts
export const getUserSpeakingAttempts = (userId) =>
    API.get(`/api/speaking-attempts/user/${userId}`).then(res => res.data);

// POST to the server route that exists: /api/speaking-attempts/saveAttempt
export const saveSpeakingAttempt = (formData) =>
    API.post("/api/speaking-attempts/saveAttempt", formData);


// Pte Core Writing
export const fetchPteCoreWritingTasks = (testNumber) =>
    API.get(`/api/ptecore/writing/test/${testNumber}`);

export const submitPteCoreWriting = (taskId, responseText, studentName, userId) =>
    API.post(`/api/ptecore/writing/submit`, { taskId, responseText, studentName, userId });

// Pte Core Speaking
export const fetchPteCoreSpeakingQuestions = (testNumber) =>
    API.get(`/api/ptecore/speaking/test/${testNumber}`);

export const submitPteCoreSpeakingAttempt = (formData) =>
    API.post(`/api/ptecore/speaking/submit`, formData);

// Pte Core Reading
export const fetchPteCoreReadingTest = (testNumber) =>
    API.get(`/api/ptecore/reading/test/${testNumber}`);

// Pte Core Listening
export const fetchPteCoreListeningTest = (testNumber) =>
    API.get(`/api/ptecore/listening/test/${testNumber}`);

export const submitPteCoreListeningSST = (taskId, responseText, studentName, userId) =>
    API.post(`/api/ptecore/listening/submit-sst`, { taskId, responseText, studentName, userId });

// Account deletion and requests
export const requestUserDeletion = (data) => API.post("/users/request-deletion", data);
export const fetchDeletionRequests = (adminPassword) => 
    API.get("/users/deletion-requests", {
        headers: { "x-admin-password": adminPassword }
    });
export const adminDeleteUser = (email, adminPassword) => 
    API.delete("/users/deleteUserByEmail", {
        headers: { "x-admin-password": adminPassword },
        data: { email }
    });

export const adminGrantAccess = (email, examType, days, adminPassword) => 
    API.post("/users/grant-access", { email, examType, days }, {
        headers: { "x-admin-password": adminPassword }
    });

export const searchUserAttempts = (params, adminPassword) =>
    API.get("/users/search-attempts", {
        headers: { "x-admin-password": adminPassword },
        params
    });



